import Html from '../html'

const SignupConfirmation = ({ signup }) => (
  <Html name="event-signup-confirmation" data={signup} />
)

export default SignupConfirmation
